import angular from "angular";
import uiRouter from "angular-ui-router";
import routing from "./operations.routes";
import _ from "lodash";

export class OperationsController {
  order = {
    field: "Operation.name",
    direction: false
  };
  filter = {
    active: true
  };

  /*@ngInject*/
  constructor($http, $uibModal, $rootScope, ngToast) {
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.ngToast = ngToast;

    this.refreshlist();
  }

  refreshlist() {
    this.$http.get("/api/operations").then(response => {
      this.operations = response.data;
    });
  }

  $onInit() {}

  sort(field) {
    if (this.order.field == field) {
      this.order.direction = !this.order.direction;
    } else {
      this.order.field = field;
      this.order.direction = false;
    }
  }

  addOperation() {
    console.log("open modal...");
    let modal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("./addOperation.html"),
      controller: "AddOperationController",
      controllerAs: "$ctrl",
      resolve: {
        operation() {}
      }
    });

    modal.result.then(operation => {
      if (operation) {
        this.refreshlist();
      }
    });
  }

  editOperation(operation) {
    console.log("open modal...");
    let modal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("./addOperation.html"),
      controller: "AddOperationController",
      controllerAs: "$ctrl",
      resolve: {
        operation() {
          console.log("returning operation on resolve:", operation);
          return _.clone(operation);
        }
      }
    });

    modal.result.then(updatedUser => {
      if (updatedUser) {
        this.refreshlist();
      }
    });
  }
}

export default angular
  .module("hccApp.operations", [uiRouter])
  .config(routing)
  .component("operations", {
    template: require("./operations.html"),
    controller: OperationsController
  }).name;



// WEBPACK FOOTER //
// ./client/app/operations/operations.component.js